import { render, staticRenderFns } from "./NewOverviewView.vue?vue&type=template&id=cc37fd48"
import script from "./NewOverviewView.vue?vue&type=script&lang=ts"
export * from "./NewOverviewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports